import {
  Component,
  input,
  model,
  forwardRef,
  ViewEncapsulation,
  ChangeDetectionStrategy,
  OnInit
} from '@angular/core';
import { RadioButton, RadioButtonStyle } from 'primeng/radiobutton';
import { BaseComponent } from 'primeng/basecomponent';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
  NgControl
} from '@angular/forms';
import { NgClass } from '@angular/common';

let nextRadiobuttonId = 0;

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'm-radiobutton',
  templateUrl: './m-radiobutton.component.html',
  styleUrls: ['./m-radiobutton.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MRadiobuttonComponent),
      multi: true
    },
    RadioButtonStyle
  ],
  imports: [RadioButton, NgClass, FormsModule]
})
export class MRadiobuttonComponent
  extends RadioButton
  implements ControlValueAccessor, OnInit
{
  readonly error = input(false);
  readonly selectedValue = model('');
  readonly label = input<string>();

  private _generatedId = `m-radiobutton-${nextRadiobuttonId++}`;

  // PrimeNG 20 applies the root host class on the host via `host: { '[class]': "cx('root')" }`.
  // This wrapper extends RadioButton but renders its OWN inner <p-radiobutton>, so that class is
  // inherited onto <m-radiobutton> too — duplicating styling. Neutralize on the wrapper host.
  override cx(): string {
    return '';
  }

  get radiobuttonInputId(): string {
    return this.inputId || this._generatedId;
  }

  override ngOnInit(): void {
    BaseComponent.prototype.ngOnInit?.call(this);
    const ngControl = this.injector.get(NgControl, null);
    if (ngControl) {
      this.control = ngControl;
      this.registry.add(ngControl, this);
    }
  }
}
